import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { TrackingCaseDocumentUploadForm, TrackingCaseDocumentUploadFormFields } from "application/tracking-case/forms";
import { TrackingCaseDocumentStreamService, DocumentTypeService } from "application/tracking-case/services";
import { action, observable, computed, runInAction } from "mobx";
import { isEmpty } from "lodash";
import moment from 'moment';

class TrackingCaseDocumentUploadModalStore extends BaseEditViewStore {
    acceptedFiles = ".csv,.zip,.pdf";
    // acceptedFiles = [".csv",".zip",".xml",".pdf"]

    fileCount = 0;
    @observable.ref accessor selectedFiles = null;
    @observable accessor isUploadInProgress = false;

    @computed
    get isDisabled() {
        return (
            !this.selectedFiles ||
            this.isUploadInProgress
        );
    }

    constructor(rootStore, componentProps) {
        const service = new TrackingCaseDocumentStreamService(rootStore.application.baasic.apiClient);
        const documentTypeService = new DocumentTypeService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: "TrackingCaseDocuments",
            // id: id,
            actions: {
                create: async (params, formData) => {
                    const response = await service.create(params, formData);
                    return response.data;
                }
            },
            errorActions: {
                onCreateError: ({ error }) => {
                    rootStore.notificationStore.error('TRACKING_CASE_DOCUMENT.CREATE.ERROR', error);
                }
            },
            FormClass: TrackingCaseDocumentUploadFormFields,
        });

        this.service = service;
        this.documentTypeService = documentTypeService;

        this.componentProps = componentProps;
        this.componentData = componentProps && componentProps.modalParams.data;

        this.documentTypeStores = [];
    }

    @action.bound
    createDocumentTypeStore() {
        return new BaasicDropdownStore(
            {
                filterable: true
            },
            {
                fetchFunc: async (term) => {
                    let params = {
                        fields: "id,name",
                        rpp: 50,
                        keyword: term
                    };

                    const response = await this.documentTypeService.find(params);
                    return response.data.item;
                }
            }
        );
    }

    @action.bound
    onFileDrop({ affectedFiles }) {
        if(!this.selectedFiles) this.selectedFiles = [];
        this.selectedFiles.push(...affectedFiles);

        var formFields = this.form.$('formFields').value;
        if(!formFields) {
            formFields = [];
        }

        affectedFiles.forEach(file => {
            this.documentTypeStores.push(this.createDocumentTypeStore());

            const _form = new TrackingCaseDocumentUploadForm();
            _form.update({
                index: this.fileCount++,
                fileName: file.name,
                fileSize: file.size,
                name: file.name.split('.').slice(0, -1).join('.')
            });

            formFields.push(_form);
        });

        this.form.$('formFields').value = formFields;
    }

    @action.bound
    removeAttachment(index) {
        var formFields = this.form.$('formFields').value;

        formFields = formFields.filter(item => item.validatedValues.index !== index);
        this.selectedFiles.splice(index, 1); // remove one element from index

        if(isEmpty(this.selectedFiles)) this.selectedFiles = null;

        this.fileCount = 0;
        formFields.forEach(item => {
            item.update({
                index:  this.fileCount++,
            })
        });

        this.form.$('formFields').value = formFields;
    }

    @action.bound
    async onClickUpload() {
        this.form.setFieldsDisabled(true);
        var anyError = false;

        try {
            this.isUploadInProgress = true;

            var counter = -1;
            for (const file of this.selectedFiles) {
                counter++;
                if(file.uploaded) continue;

                file.uploading = true;

                var rowValue = this.form.$('formFields').value[counter].validatedValues;

                const formData = new FormData();
                formData.append("file", file.getRawFile(), file.name);

                try {
                    await this.actions.create(
                        {
                            trackingCaseId: this.componentData.trackingCaseId,
                            filename: rowValue.fileName,
                            name: rowValue.name,
                            documentTypeId: rowValue.documentTypeId,
                            documentFormId: rowValue.documentFormId,
                            validFrom: rowValue.validFrom ?  moment(rowValue.validFrom).format() : null,
                            validTo: rowValue.validTo ?  moment(rowValue.validTo).format() : null,
                            description: rowValue.description
                        },
                        formData
                    );

                    file.errorMsg = null;
                    file.uploaded = true;
                } catch (err) {
                    file.uploaded = false;

                    if(err.data && err.data.message){
                        file.errorMsg = err.data.message;
                    }else{
                        file.errorMsg = "Error occured";
                    }

                    anyError = true;
                }

                file.uploading = false;
            }
        } catch (err) {
            return this.onCreateError(err);
        }

        this.form.setFieldsDisabled(false);

        runInAction(() => {
            this.isUploadInProgress = false;
        });

        if(!anyError){
            this.rootStore.notificationStore.success("TRACKING_CASE_DOCUMENT.MESSAGES.UPLOAD_SUCCESS");
            this.componentProps.modalParams.close();
        }

        this.componentData.fetchTable();

        return !anyError;
    }
}

export default TrackingCaseDocumentUploadModalStore;
